import { Box, Container, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const yearDisplay = currentYear === 2026 ? "2026" : `2026–${currentYear}`;

  return (
    <Box
      component="footer"
      sx={{ borderTop: "1px solid", borderColor: "divider", py: 3, mt: "auto" }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: 1, sm: 2 },
          }}
        >
          <Typography variant="caption" color="text.secondary">
            © {yearDisplay} TL Lab. All rights reserved.
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Link component={RouterLink} to="/privacy" variant="caption" color="text.secondary" underline="hover">
              Privacy
            </Link>
            <Link component={RouterLink} to="/terms" variant="caption" color="text.secondary" underline="hover">
              Terms of Service
            </Link>
            <Link component={RouterLink} to="/technology" variant="caption" color="text.secondary" underline="hover">
              Technology
            </Link>
            <Link component={RouterLink} to="/skill" variant="caption" color="text.secondary" underline="hover">
              Skill
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
